import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router'

import { ClientListClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/ClientListClient'
import { ClientMessagingIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ClientMessagingIcon'
import { ProfileCircleIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ProfileCircleIcon'
import { HoverActionItem } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/hoverActions/HoverActions'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { actions as mixpanelActions, mixpanelEvents } from '../../../../../mixpanel/mixpanelConstants'
import { track } from '../../../../../mixpanel/mixpanelTracking'
import { CLIENT_HOME, MESSENGER } from '../../../common/constants/routingConstants'
import { useAppDispatch } from '../../../data/store'
import { setSelectedClientId } from '../../../lyraTherapy/clients/clientDetails/data/ltClientSlice'

export type SharedHoverActionPanel = 'risk_alerts' | 'tasks' | 'client_activity' | 'agenda'

export const useSharedItemHoverActions = (
  panel: SharedHoverActionPanel,
): ((client: ClientListClientObject) => HoverActionItem[]) => {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return useCallback(
    (client: ClientListClientObject): HoverActionItem[] => [
      {
        id: 'message',
        icon: <ClientMessagingIcon />,
        label: intl.formatMessage({ defaultMessage: 'Message client', description: 'Hover action label' }),
        testId: tID('useSharedItemHoverActions-message'),
        onPress: () => {
          track({
            event: mixpanelEvents.BUTTON_PRESS,
            action: mixpanelActions.DASHBOARD_SHARED_HOVER_ACTION,
            properties: { panel, hover_action: 'message' },
          })
          dispatch(setSelectedClientId(client.id))
          navigate(MESSENGER.route)
        },
      },
      {
        id: 'profile',
        icon: <ProfileCircleIcon />,
        label: intl.formatMessage({ defaultMessage: 'Open profile', description: 'Hover action label' }),
        testId: tID('useSharedItemHoverActions-profile'),
        onPress: () => {
          track({
            event: mixpanelEvents.BUTTON_PRESS,
            action: mixpanelActions.DASHBOARD_SHARED_HOVER_ACTION,
            properties: { panel, hover_action: 'profile' },
          })
          dispatch(setSelectedClientId(client.id))
          navigate(CLIENT_HOME.route)
        },
      },
    ],
    [intl, dispatch, navigate, panel],
  )
}
